import {
  IRoofStructure,
  RoofStructureActions,
  RoofStructureState,
  RoofStructureMutations,
  RoofStructureGetters
} from "./types";
import { DefineActions } from "vuex-type-helper";
import * as types from "@/store/mutation-types";
import {
  GenericCreateOne,
  GenericDeleteOne,
  GenericGetMany,
  GenericGetOne,
  GenericMakeRequest,
  GenericUpdateOne
} from "@/store/helpers/actions";
import RoofStructureService from "@/services/roofStructure.service";

export const actions: DefineActions<
  RoofStructureActions,
  RoofStructureState,
  RoofStructureMutations,
  RoofStructureGetters
> = {
  createRoofStructure: GenericCreateOne<
    RoofStructureState,
    RoofStructureGetters,
    RoofStructureActions,
    RoofStructureMutations,
    IRoofStructure
  >(RoofStructureService, types.SET_ITEM as any),
  getRoofStructures: GenericGetMany<
    RoofStructureState,
    RoofStructureGetters,
    RoofStructureActions,
    RoofStructureMutations
  >(RoofStructureService, "roofStructures", types.SET_ITEM as any),
  getRoofStructure: GenericGetOne<
    RoofStructureState,
    RoofStructureGetters,
    RoofStructureActions,
    RoofStructureMutations
  >(RoofStructureService, types.SET_ITEM as any),
  deleteRoofStructure: GenericDeleteOne<
    RoofStructureState,
    RoofStructureGetters,
    RoofStructureActions,
    RoofStructureMutations
  >(RoofStructureService, types.DELETE_ITEM as any),
  updateRoofStructure: GenericUpdateOne<
    RoofStructureState,
    RoofStructureGetters,
    RoofStructureActions,
    RoofStructureMutations,
    { id: string; update: Partial<IRoofStructure> }
  >(RoofStructureService, types.SET_ITEM as any),
  deleteRoofStructures: GenericMakeRequest<
    RoofStructureState,
    RoofStructureGetters,
    RoofStructureActions,
    RoofStructureMutations
  >(RoofStructureService.deleteBulkRoofStructures.bind(RoofStructureService)),
  deleteBulkRoofStructures: async ({ commit }, roofStructureIds) => {
    try {
      commit(
        types.SET_STATE as any,
        { key: "makingApiRequest", value: true } as any
      );
      const response = await RoofStructureService.deleteBulk(roofStructureIds);
      return response.data;
    } finally {
      commit(
        types.SET_STATE as any,
        { key: "makingApiRequest", value: false } as any
      );
    }
  },
  restoreBulkRoofStructures: async ({ commit }, roofStructureIds) => {
    try {
      commit(
        types.SET_STATE as any,
        { key: "makingApiRequest", value: true } as any
      );
      const response = await RoofStructureService.restoreBulk(roofStructureIds);
      return response.data;
    } finally {
      commit(
        types.SET_STATE as any,
        { key: "makingApiRequest", value: false } as any
      );
    }
  }
};
